import { markdownToHtml } from '@/utils/markdown-to-html';

export type PolicyType = 'terms' | 'private'
export enum EPolicyVersion {
  V_20220215 = '20220215'
}

const defaultVersion = EPolicyVersion.V_20220215;

export async function getPolicyHtml(
  type: PolicyType,
  language: string,
  version: EPolicyVersion = defaultVersion,
): Promise<string> {
  // const res = await fetch(`/assets/markdown/${version}/${type}_${language}.md`);
  const res = await fetch(`/assets/markdown/${version}/${type}_${'ko'}.md`);
  if (res.status === 200) {
    const data = await res.text();
    return markdownToHtml(data);
  }
  if (res.status === 404) {
    const data = await getPolicyHtml(type, 'ko', version);
    return data;
  }
  return '';
}
